module.exports = __webpack_public_path__ + "static/media/genie1.d80e50d7.webm";